// export const OperatorUrl='http://localhost:3001/loading';
// vercel
// export const OperatorUrl = 'https://biller-q-company-react.vercel.app/loading';
// Live
export const OperatorUrl='https://billerq.app/loading';
// Public Url
export const getInvoice = 'get-shared-invoice';
export const getOrderRecentPayment = 'admin/get-order-recent-payment';
export const getMasterDetails = "get-client-profile-data";  
export const updatePassword="client-change-password"
export const getMasterProfile = "edit-client-data";
export const registerSub="register-from-admin";
export const getclientpackage="get-client-package"
export const getpackageselect="admin/get-package-select"
export const getAllPackage="admin/get-all-package"
export const getCouponUsageReport="admin/get-coupon-usage-report"
export const updateMasterProfile = "update-client-data";
export const getCompanyInvoice = "get-company-invoices";
export const getCompanyInvoices = "get-user-invoices";
export const getCompanyPayment = "get-company-payment";
export const getCompanyPayments = "get-payment-list";
export const getCompanyDetails = "/user-connection-data-public";
export const showUserSubscription ="admin/show-user-subscription"
export const getUserData="admin/get-user-data"
export const getCompanyProfile = "/get-company-data-public";
export const getCompanySubscription = "get-user-subscription";
export const getMasterSubscription = "get-user-subscription-list";
export const headerSearch="admin/header-search"
export const getIndustry = "admin/get-all-industry";
export const getZones = "admin/get-zones";
export const getZoneById = "admin/edit-zone";
export const addZone = "admin/add-zone";
export const editZone = "admin/update-zone";
export const deleteZone = "admin/remove-zone";
export const getZoneSelect = "admin/get-zone-select";
export const getUserSelect="admin/get-user-select"
export const getCurrency = "admin/get-currency-list";
export const getUserDetails="admin/edit-user"
export const updateUserAccount="admin/update-user-data"
export const deleteUser="admin/delete-user"
export const CompanyAdd = "admin/add-company";
export const getPaymentDueSubscription="admin/get-payment-due-subscription";
export const getGeneratePayment = "generate-public-payment";
export const getMakePayment = "make-public-payment";
export const postMakePayment = "store-local-payment";
export const getOtp = "generate-login-otp";
export const adminLogin = "admin/login";
export const getIndustryData = "admin/get-industry-data";
export const deleteIndustry = "admin/remove-industry";
export const uploadIndustry = "admin/update-industry";
export const addIndustryURL = 'admin/add-industry';
export const getpaymentId = "admin/get-payment-receipt";
export const getpaymentIdMaster = "get-payment-receipt";
export const postCoupon = "check-coupon-code-subscription";
export const statusChangeIndustry = "admin/change-status";
export const addTaxGroup = "admin/add-tax-group";
export const addTaxSub = "admin/add-tax";
export const getTaxGroup = "admin/get-tax-groups";
export const uploadTaxGroup = "admin/update-tax-group";
export const statusTaxGroup = "admin/change-tax-group-status";
export const deleteTaxGroup = "admin/remove-tax-group";
export const postTaxData = "admin/tax-data";
export const getTaxEdit = "admin/edit-tax";
export const uploadTax = "admin/update-tax";
export const statusTax = "admin/change-tax-status";
export const deleteTax = "admin/remove-tax";
export const getAccount = "admin/show-account";
export const packageReport="admin/get-package-report"
export const getMonthlyIndustryRevenueReport="admin/get-monthly-industry-revenue-report"
export const getMonthlyCompanyRevenueReport="admin/get-monthly-company-revenue-report"
export const getMonthlyPlanRevenueReport="admin/get-monthly-plan-revenue-report"
export const getPackageRevenueReport='admin/get-package-revenue-report'
export const getNotificationCreditReport ="admin/get-notification-credit-report"
export const getNotificationUsageReport="admin/get-notification-usage-report"
export const postAddAccount = "admin/add-account";
export const uploadAccount = "admin/update-account";
export const deleteAccount = "admin/remove-account";
export const getPaymentList = "admin/get-payment_list";
export const getInvoiceList = "admin/get-recent-invoices";
export const postShowTemp = "admin/show-temp-users";
export const userswithoutsubscription="admin/get-users-without-subscription"
export const postShowTrail = "admin/get-trail-expired";
export const getUserList="admin/get-user-list";
export const postSmsStatus = "admin/change-sms-status";
export const postSuspendCustomer = "admin/suspend-user-account";
export const suspendCompany="admin/suspend-company"
export const postActiveCustomer = "admin/activate-user-account";
export const activateCompany="admin/activate-company"
export const getIndustryUser = "admin/get-industry-users";
export const getCompanyList = "admin/get-company-list";
export const getStaticWidget = "admin/get-user-profile-data";
export const getPackages = "admin/get-packages";
export const addPackages = "admin/add-package";
export const postExtendDays = "admin/update-skip-due";
export const uploadPackages = "admin/update-package";
export const checkPlanLimit="admin/check-plan-limit"
export const statusChangePackage = "admin/change-package-status";
export const deletePackage = "admin/remove-package";
export const deleteInvoice="admin/delete-invoice"
export const deleteComany = "admin/delete-company";
export const getShowOrder = "admin/show-order";
export const getShareApi = "admin/get-order-number";
export const getInvoiceDetail = "admin/get-invoice-data";
export const getUserSubscription = "admin/show-user-subscription";
export const getCompanyData = "admin/get-user-company-data";
export const getUsers = "admin/get-user-for-select";
export const getStaff="admin/get-staff-list";
export const addUserAccount="admin/add-user-account"
export const getRole = "admin/get-roles";
export const deleteRole = "admin/delete-role";
export const addRole = "admin/add-roles";
export const getPermission = "admin/show-permission";
export const getAddons = "admin/get-add-ons";
export const deleteAddons = "admin/remove-add-on";
export const addAddons = "admin/add-add-on";
export const editAddons = "admin/update-add-on";
export const getAddress = "admin/show-address";
export const getPersonalInfo = "admin/get-users";
export const deleteAddress = "admin/remove-address";
export const getPayment = "admin/view-payment";
export const getSingleOrderDetail = "admin/get-single-order-detail";
export const getPaymentMethod = "admin/get-payment-method-for-select";
export const getAccountOption = "admin/get-account-for-select";
export const addCoupon = "admin/add-coupon";
export const getCoupon = "admin/get-coupon";
export const getDashboardCounts = "admin/total-counts";
export const getRevenueChartApi ="admin/revenue-chart"
export const getSubscriptionChartApi ="admin/subscription-chart"
export const addSetupCost= "add-setup-cost"
export const editCoupon = "admin/edit-coupon";
export const getStatus = "admin/change-coupon-status";
export const getPaymentStatus="admin/change-pm-status"
export const updateCoupon = "admin/update-coupon";
export const deleteCoupon = "admin/delete-coupon";
export const showPaymentMethod = "admin/show-payment-methods ";
export const addPaymentMethod = "admin/add-payment-method";
export const getAccountSelect = "admin/get-account-for-select";
export const editPaymentMethod = "admin/edit-payment-method";
export const updatePaymentMethod = "admin/update-payment-method";
export const deletePaymentMethod = "admin/remove-payment-method";
export const editSubscription = "admin/edit-subscription";
export const updateSubscription = "admin/update-subscription";
export const updatePersonalInfo = "admin/update-user-data";
export const emailVerification = "admin/admin-check-email";
export const uploadPassword = "admin/admin-change-password";
export const createInvoice = 'admin/generate-invoice';
export const getRecentSubscription = 'admin/recent-subscribers';
export const getRecentPayment= 'admin/recent-payments';
export const getPaymentDue= 'admin/payment-due-list';
export const getExpireSub= 'admin/expired-subscriptions';
export const getExpireToday= 'admin/expire_today';

//notification channel
export const getNotificationChannel= 'admin/get-channel';
export const addNotificationChannel= 'admin/add-channel';
export const editGetNotifcationChannel= 'admin/edit-channel';
export const updateNotifcationChannel= 'admin/update-channel';
export const deleteNotifcationChannel= 'admin/delete-channel';
export const statusChangeNotifcationChannel= 'admin/change-channel-status';

//notification settings
export const getNotificationSettings= 'admin/get-notification';
export const addNotificationSettings= 'admin/add-notification';
export const statusChangeNotificationSettings= 'admin/change-notification-status';
export const deleteNotificationSettings= 'admin/delete-notification';
export const getNotificationDetails= 'admin/edit-notification';
export const updateNotification= 'admin/update-notification';

//get all users
export const getAllUsers = 'admin/get-user-for-select';

//enquiries
export const publicSampleDownloadEnquiry = 'https://watercrm.quadleo.com/public/storage/import_files/enquiry_import.xlsx';
export const showEnquiry="admin/show-enquiry"
export const storeEnquiry="admin/store-enquiry"
export const deleteEnquiry ="admin/delete-enquiry"
export const updateEnquiry="admin/update-enquiry"
export const assignEnquiry="admin/assign-enquiry"
export const enquiryChangeStatus="admin/enquiry-change-status"
export const storeLead="admin/store-lead"
export const showLead="admin/show-lead"
export const assignLead="admin/assign-lead"
export const statusChangeLead="admin/lead-change-status"
export const updateLead="admin/update-lead"
export const showfollowup="admin/show-followup"
export const storeFolloUp="admin/store-followup"
export const followUpStatusChange="admin/followup-change-status"
export const getAllOverdues="admin/overdue-list"
export const enquirystatusCount="admin/enquiry-status-count"
export const leadsCounts= "admin/lead-count"
export const overdues="admin/overdues"
export const postEnquiryImport="admin/enquiry-import"

